import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ElementRef, Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

export interface ChatMessage {
  text: string;
  date: string;
  type: 'U' | 'A';
}

export interface ChatResponse {
  response: string;
}

@Injectable()
export class ChatService {

  private static elementRef: ElementRef<HTMLDivElement> | null = null;

  public get open() {
    return ChatService.elementRef?.nativeElement.classList.contains("show");
  }

  public get type(): string {
    return localStorage.getItem("type") ?? "tool";
  }

  public set type(type: string) {
    localStorage.setItem("type", type);
  }

  public loading = false;

  constructor(private http: HttpClient) {}

  public registerElement(elementRef: ElementRef<HTMLDivElement>) {
    ChatService.elementRef = elementRef;
  }

  public toggle() {
    ChatService.elementRef?.nativeElement.classList.toggle("show");
  }

  public toggleType() {
    this.type = this.type === "chat" ? "tool" : "chat";
  }

  public sendMessage(message: { text: string, user_id: string, organization_id: string, chat_id: string, token: string }) {
    this.loading = true;

    const data = { 
      message: message.text, 
      type: this.type, 
      user_id: message.user_id,
      organization_id: message.organization_id,
      chat_id: message.chat_id,
    }

    /**
     * Token JWT emitido pelo backend do Locavia Web, recebido via query param do iframe.
     * A API do assistente valida a assinatura com o mesmo segredo (JWT_SECRET).
     */
    const token = message.token.replace(/^Bearer\s+/i, "");
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });

    return this.http
      .post<ChatResponse>(environment.apiUrl + "/message", data, { headers })
      .pipe(map(({ response }) => { this.loading = false; return response ?? "Não foi possível comunicar com o assistente, tente novamente." }));
  }

  public loadMessages() {
    this.loading = true;

    return new Observable<ChatMessage[]>(subscriber => {
      subscriber.next([
        {
          type: 'A',
          text: 'Olá, sou a **Tellma**, uma Inteligência Artificial do Locavia Web. Como posso te ajudar?',
          date: new Date().toISOString(),
        }
      ]);

      this.loading = false;
    });
  }
}